import { addNotification, addNotifications } from '../../actions/notifications';
import { Dispatch } from '../../redux.types';

export const notificationMiddleware = ({
  dispatch,
}: {
  dispatch: Dispatch;
}): any => {
  return (next) => (action) => {
    const { notification, notifications }: any = action;

    if (notification) {
      dispatch(addNotification(notification));
    }

    if (notifications) {
      dispatch(addNotifications(notifications));
    }

    return next(action);
  };
};
